import React, {useEffect, useState} from 'react';
import moment from 'moment';

import AiBotIcon from '../../../assets/svgComponents/AiBotIcon';
import AutoTextTyperComponent from '../../common/genericComponents/autoTextTyperComponent';
import MultiStateButton from '../../common/genericComponents/redesign/multiStateButton/multiStateButton';

import VIDABOO_CONSTANTS from '../../../config/consts';

import '../aiChatMsgContentWrapperComponent/aiChatMsgContentWrapperComponent.css';
import './aiHandoffPendingChatMsgComponent.css';
import NotificationAiBotIcon from '../../../assets/svgComponents/NotificationAiBotIcon';

const AiHandoffPendingChatMsgComponent = ({
  isDemo = false,
  isDisabled = false,
  isMentorSide = true,
  isTakeOwnershipFlowRunning = true,
  chatMessageDto = {},
  chatRowOptionsElement = null,
  getTextMessage = () => {},
  onTakeOwnershipBtnClick = () => {},
}) => {
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const [chatMsgTime, setChatMsgTime] = useState(null);

  useEffect(() => {
    const msgSendTime = chatMessageDto?.sendTime;
    const chatMsgTime = moment(msgSendTime || undefined).format('D MMMM HH:mm');
    setChatMsgTime(chatMsgTime);
  }, [chatMessageDto?.sendTime]);

  const handleTypingComplete = () => {
    setIsTypingComplete(true);
  };

  return (
    <div
      className={`et-ai-chat-msg-content-wrapper-container ${!isMentorSide ? 'et-ai-chat-msg-content-wrapper-container-client' : ''}`}>
      <div className="et-acmcwc-ai-content-msg-time-wrap">
        <div
          className={`et-acmcwc-ai-bot-icon-name-msg-wrap ${isMentorSide ? 'et-acmcwc-ai-bot-icon-name-msg-wrap-color-border' : ''}`}>
          {isMentorSide && (
            <div className="et-acmcwc-abinmw-non-animated-border" />
          )}
          <div
            className={`${isMentorSide ? 'et-acmcwc-abinmw-wrap-non-animated' : 'et-acmcwc-abinmw-wrap'}`}>
            {!isMentorSide ? (
              <div className="et-acmcwc-ai-bot-wrap">
                <AiBotIcon />
              </div>
            ) : (
              <div className="et-acmcwc-ai-bot-wrap-mentor">
                <NotificationAiBotIcon />
              </div>
            )}
            <div className="et-acmcwc-ai-bot-name-msg-wrap">
              <div className="et-acmcwc-ai-bot-name">
                {VIDABOO_CONSTANTS.AI_BOT_NAME}
              </div>
              <AutoTextTyperComponent
                isAnimationDisable={!chatMessageDto.isMsgAddedOrUpdatedViaWs}
                text={
                  isMentorSide
                    ? 'You are about to take control of this chat, click control to start chat with the customer'
                    : chatMessageDto.messageText
                }
                getTextMessage={getTextMessage}
                onTypingComplete={handleTypingComplete}
              />
              {isTypingComplete && isMentorSide && (
                <div className="et-ahpcmc-h-take-ownership-btn">
                  <MultiStateButton
                    isDisabled={isDemo || isDisabled}
                    isPrimaryBtn
                    showSpinner={isTakeOwnershipFlowRunning}
                    btnTxt="Take control of the conversation"
                    onClick={onTakeOwnershipBtnClick}
                  />
                </div>
              )}
              {chatRowOptionsElement && (
                <div className="et-acmcwc-ai-msg-chat-row-options">
                  {chatRowOptionsElement}
                </div>
              )}
            </div>
          </div>
        </div>
        <p className="et-acmcwc-ai-msg-time" dir="auto">
          {chatMsgTime}
        </p>
      </div>
    </div>
  );
};

export default AiHandoffPendingChatMsgComponent;
